import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/header.css';
import './styles/footer.css';
import './styles/products.css';
import './styles/product-details.css';
import './styles/forms.css';
import './styles/responsive.css';
import './styles/pages.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);